import { defineStore } from 'pinia';
import { MaterialState } from './types';
// 物料管理
const useMaterialStore = defineStore('material', {
  state: (): MaterialState => ({
    materialCenterTableIsFull: true, // 采购中台表格是否放大
    materialPurchaseTableIsFull: true, // 物料采购表格是否放大
  }),

  getters: {},

  actions: {
    setMaterialCenterTableIsFull(data?: boolean) {
      this.materialCenterTableIsFull = data ?? false;
    },
    setMaterialPurchaseTableIsFull(data?: boolean) {
      this.materialPurchaseTableIsFull = data ?? false;
    },
  },
});

export default useMaterialStore;
